<template>
  <div class="allenamento-feedback">


    <table class="tabella-confronto" v-cloak>
      <thead>
        <tr>
          <th></th>
          <th>Assegnato</th>
          <th>Eseguito</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Durata</td>
          <td>{{tempoAssegnato}}</td>
          <td>{{tempoEseguito}}</td>
        </tr>

        <tr v-if="!isPalestra(allenamento.sport_id)">
          <td>Distanza <small>({{getUnitFromSport(allenamento.sport_id)}})</small></td>
          <td>{{distanzaAssegnata}}</td>
          <td>{{distanzaEseguita}}</td>
        </tr>

        <tr v-if="!isPalestra(allenamento.sport_id)">
          <td>Trimp</td>
          <td>{{formatTrimp(allenamento.trimp)}}</td>
          <td v-if="allenamento.attivita">{{formatTrimp(trimpAttivita)}}</td>
          <td v-else>{{formatTrimp(feedback.trimp)}}</td>
        </tr>
      </tbody>
    </table>

        <v-btn v-if="!allenamento.attivita" class="my-4" @click="apriAggiungiManuale">
        <v-icon class="mr-2">mdi-plus</v-icon>Aggiungi attività manuale</v-btn>

    <div class="dati-percentuale" v-if="feedback.percentuale">
      <span v-text="feedback.percentuale"></span>%
    </div>

<v-card class="card-feedback">

      <v-card-title>Come è andato l'allenamento?</v-card-title>
    <msp-valutazione-allenamento :readonly="!isEditable" @update="onUpdateValutazione" :calendario-id="feedback.calendario_id" :init-value="feedback.valutazione" />
    


      <v-card-title>Percezione dello sforzo <span class="ml-1 mr-1 nowrap">(RPE)</span></v-card-title>
      <rpe
      :selected="feedback.rpe"
      :readonly="!isEditable"
      @select = "updateRpe"
      ></rpe>
    
    <v-btn block @click.prevent.stop="openChatCalendario(allenamento.calendario_id)"><v-icon class="mr-2">mdi-chat-outline</v-icon> Inserisci un commento</v-btn>
</v-card>
  </div>


</template>

<script>
import api from "@mixins/api.js";
import allenamentoCalcoli from "@src/js/vue/mixins/allenamentoCalcoli.js";
import rpe from "./rpe.vue";
import mspValutazioneAllenamento from "./MspValutazioneAllenamento.vue";
import { mapGetters } from 'vuex'
import messaggi from "@mixins/messaggi.js";

const component = {
    components: {
        rpe,
        mspValutazioneAllenamento,
    },
    mixins: [
        allenamentoCalcoli,
    ],
    props: [
        'allenamento'
    ],
    data: function ()
    {

        let data = {
            allenamenti: [],
            loadingAllenamenti: false,
            // il completamento manuale (senza device) passa ora dall'attività associata
            // (t_sessioni_allenamento_v3_hdr, device='manuale', vedi EditAttivitaManuale.vue):
            // niente più durata/distanza qui, solo rpe/note/valutazione
            feedback:  {
                mt: 0,
                noteAttivita: '',
                note: '',
                percentuale: 0,
                rpe: 0,
                calendario_id: 0,
                valutazione: 0,
            },
        }
        return data;
    },
    created: function ()
    {

    },

    computed: {
        ...mapGetters('atleti', [
            'atleta',
        ]),
        ...mapGetters('utente', [
            'utente',
        ]),
        isEditable: function () {
            return (this.utente && this.utente.is_atleta);
        },

        tempoAssegnato: function () {
            return this.allenamento?.totalone && this.secondsToHms(this.allenamento.totalone.sec);
        },

        tempoEseguito: function () {
            return this.allenamento?.attivita?.durata && this.secondsToHms(this.allenamento.attivita.durata);
        },

        percentualeDurataAttivita: function () {
            if (!(this.allenamento?.attivita?.durata && this.allenamento?.totalone?.sec)) {
                return "";
            }

            return this.getPercentuale(this.allenamento.attivita.durata, this.allenamento.totalone.sec, " %");
        },

        distanzaAssegnata: function () {
            return this.allenamento?.totalone && this.convertDistanceFromIdSport(this.allenamento.totalone.mt, this.allenamento.sport_id);
        },

        distanzaEseguita: function () {
            return this.allenamento?.attivita?.metri && this.convertDistanceFromIdSport(this.allenamento.attivita.metri, this.allenamento.sport_id);
        },

        percentualeDistanzaAttivita: function () {
            if (!(this.allenamento?.attivita?.metri && this.allenamento?.totalone?.mt)) {
                return "";
            }

            return this.getPercentuale(this.allenamento.attivita.metri, this.allenamento.totalone.mt, " %");
        },

        percentualeTrimpAttivita: function () {
            if (!(this.allenamento?.attivita?.trimp && this.allenamento?.trimp)) {
                return "";
            }

            return this.getPercentuale(this.allenamento.attivita.trimp, this.allenamento.trimp, " %");
        },

        trimpAttivita: function () {
            const trimp = this.allenamento?.attivita?.trimp;
            if (!trimp) {
                return false;
            }
            return trimp;
        },

    },

    watch: { },

    mounted: function () {
        this.init();
    },

    methods: {
        apriAggiungiManuale: function () {
            this.$emit("apri-aggiungi-manuale");
        },
        openChatCalendario: async function (calendario_id) {
            const newChat = await messaggi.addChat('calendario', calendario_id);
            if (!newChat) return;
            const chatId = newChat.chat_id;
            this.$store.dispatch("calendario/setDialog",true);
            this.$router.push("/chats/"+chatId);
        },

        init () {
            this.feedback = {
                ...this.feedback,
                calendario_id: this.allenamento.calendario_id
            };
            this.loadFeedback(this.allenamento.calendario_id)
                .then(
                    ()=>{
                        this.syncRpe();
                    }
                );
        },


        associaAttivita: function (attivita_id) {
            this.loading = true;
            let calendario_id = this.allenamento.calendario_id
            const url =  process.env.VUE_APP_API_BASE_URL + "/api/v2/attivita.php?associa&id="+attivita_id;
            const data = {
                'calendario_id': calendario_id
            };
            return new Promise(
                (resolve, reject)=>{
                    api(url, 'POST', data)
                        .then(
                            (response)=>{
                                this.loading = false;
                                resolve(response.data);
                            }
                        )
                        .catch((error)=>{
                            reject(error);
                        })

                }
            );
        },
        dissociaAllenamento: function (id)
        {
            this.loading = true;
            return new Promise((resolve, reject)=>{
                const url =  process.env.VUE_APP_API_BASE_URL +'attivita.php?dissocia&id='+id;
                api(url, 'PUT', {})
                    .then(
                        (result)=>{
                            this.loading = false;
                            if (result.success) {
                                resolve(true);
                            } else {

                                resolve(false);
                            }
                        },
                        (error)=>{
                            this.loading = false;
                            reject(error);
                        }
                    )
            });
        },

        selectAllenamento: function (el) {
            this.associaAttivita(el.id);
        },

        loadFeedback: function (calendario_id) {
            return new Promise((resolve)=>{
                const url = process.env.VUE_APP_API_BASE_URL + "/api/v2/feedback.php?calendario_id="+calendario_id;
                api(url, 'GET')
                    .then((result)=>{
                        if (result.success) {
                            this.feedback={
                                ...this.feedback,
                                ...result.data,
                                calendario_id: calendario_id,
                            };
                        }
                        resolve(result);
                    })
            })
        },

        syncRpe: function () {
            if (!this.allenamento.attivita) {
                return Promise.resolve({success: false});
            }

            if (this.feedback.rpe) {
                return this.updateRpeAttivita(this.feedback.rpe)
            }
        },

        updateRpeAttivita: function (rpe) {
            const attivita_id = this.allenamento.attivita_id;
            if (!attivita_id) {
                return Promise.resolve({success:false});
            }

            const url =  process.env.VUE_APP_API_BASE_URL + "/api/v2/attivita.php?rpe&id="+attivita_id;
            const data = {
                'rpe': rpe
            };
            return new Promise((resolve, reject)=>{
                api(url, 'POST', data)
                    .then(
                        (response)=>{
                            this.loading = false;
                            resolve(response.data);
                        }
                    )
                    .catch((error)=>{
                        reject(error);
                    })
            });
        },

        updateRpe: function (rpe) {
            this.feedback.rpe = rpe.rpe;
            this.updateFeedback();
            if (this.allenamento.attivita) {
                this.updateRpeAttivita(rpe.rpe);
            }
        },

        updateNote: function () {
            this.updateFeedback();
        },

        saveFeedback: function () {
            const url =  process.env.VUE_APP_API_BASE_URL + "/api/v2/feedback.php";
            const data = this.feedback;
            return api(url, 'POST', data);
        },

        onUpdateValutazione: function ({valutazione}) {
            this.feedback.valutazione = valutazione;
            this.onUpdate();
        },

        onUpdate: function () {
            this.$emit('update-feedback', this.feedback);
        },

        updateFeedback: function () {
            this.MSP().debounce(async ()=>{
                await this.saveFeedback();
                this.onUpdate();
            }, 300)();

        },

    }
}
export default component;
</script>

<style lang="scss">
.allenamento-feedback {

  position: relative;
  .dati-commento {
    width: 100%;
  }

  .rpe-items {
    justify-content: center;
  }

  .tabella-confronto {
    width: 100%;
    margin: 10px 0;
    border-collapse: collapse;
    border-bottom: 1px solid var(--col-grigio-chiaro);

    th, td {
      text-align: left;
      font-weight: normal;
      padding: 4px 12px 4px 0;
    }
    th:last-child, td:last-child {
      font-weight: bold;
    }
    thead th {
      padding-bottom: 8px;
      border-bottom: 1px solid var(--col-grigio-chiaro);
    }
    tbody tr:last-child td {
      padding-bottom: 10px;
    }
  }
}
[class*="slots-grid"] {
  display: grid;
  grid-gap: var(--ui-space);
  grid-template-columns: auto repeat(var(--cols),auto);
}
.slots-grid-2 {
  --cols: 2;


}
.grid-full {
  grid-column: 1 / -1;
}
.slots-grid-3 {
  --cols: 3;
}
.slots-grid-4 {
  --cols:4;
}
.slots-grid-5 {
  --cols:5;
}
.card-feedback {
  .v-card__title {
    font-weight:bold;
    font-size: 1em;
    text-align: center;
    justify-content: center;
  }
}
</style>
